/* eslint-disable object-shorthand */
import { observable, action } from 'mobx';
import RFBluetoothInstance from '../../native-interact/RFBluetooth';
import { getFDISK, waitRebootCpu1, getFDISKForProd } from '../../service/command';
import { event } from '../../native-interact/EventEmmiter';

export const process = [
  {
    name: '进入仓储模式',
    abort: '1',
    overtime: 60,
    execute: function () {
      return RFBluetoothInstance.sendCommand('goto froz', this);
    }
  },
  {
    name: '进入安装模式',
    abort: '1',
    overtime: 60,
    execute: function () {
      return RFBluetoothInstance.sendCommand('goto install', this);
    }
  },
  {
    name: '获取磁盘分区',
    abort: '1',
    overtime: 60,
    execute: function () {
      return getFDISK();
    }
  },
  {
    name: '开启日志',
    abort: '1',
    overtime: 60,
    execute: function () {
      return RFBluetoothInstance.sendCommand('log bt 600', this);
    }
  },
  {
    name: '分区重置',
    abort: '1',
    overtime: 60,
    execute: function () {
      return RFBluetoothInstance.sendCommand('fatfs mkfs', this);
    }
  },
  {
    name: '发送重启cpu1命令',
    abort: '1',
    overtime: 60,
    execute: function () {
      return RFBluetoothInstance.sendCommand('reboot cpu1', this);
    }
  },
  {
    name: '等待重启cpu1',
    abort: '1',
    execute: function () {
      return waitRebootCpu1();
    }
  },
  {
    name: '进入仓储模式',
    abort: '1',
    overtime: 60,
    execute: function () {
      return RFBluetoothInstance.sendCommand('goto froz', this);
    }
  },
  {
    name: '进入安装模式',
    abort: '1',
    overtime: 60,
    execute: function () {
      return RFBluetoothInstance.sendCommand('goto install', this);
    }
  },
  {
    name: '进入工作模式',
    abort: '1',
    overtime: 60,
    execute: function () {
      return RFBluetoothInstance.sendCommand('goto work', this);
    }
  }
];

const processTasks = process.map((item) => {
  return Object.assign({}, item, {
    status: 'default',
    text: `${item.name}中...`,
    success: `${item.name}完成`,
    error: `${item.name}失败`,
    execute: item.execute.bind(item)
  });
});

const forceFixTasks = processTasks.slice(0, 7);
forceFixTasks[2] = {
  name: '获取磁盘分区',
  abort: '0',
  overtime: 60,
  execute: function () {
    return getFDISKForProd();
  }
};

export default class FixProcess {
  @observable tasks = processTasks.slice(0, 7);

  @observable forceTasks = forceFixTasks;

  @observable tasksSeond = processTasks.slice(7);

  @observable done = [];

  @action addTasks(task) {
    this.done.push(task);
  }

  @action stopTask() {
    RFBluetoothInstance.endStep();
    event.endStep();
  }
}

export const fixStore = new FixProcess();
